import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { PageContentService } from '../services/page-content.service';
import { SafeHtml, DomSanitizer, Title, Meta } from '@angular/platform-browser';
import { Subscription } from 'rxjs/internal/Subscription';   

@Component({
  selector: 'app-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.css']
})
export class PageContentComponent implements OnInit {
  @Output() public onLoaded: EventEmitter<any> = new EventEmitter();
  @Input() pageUrl: string;
  @Input() displayBanners: boolean = true;
  @Input() bannerImages: Array<string>;
  @Input() mediaReplacement: string;
  @Input() paths: Array<string>;
  @Input() displayTrail: boolean = true;

  pageId$: number = 0;

  primaryPageData$ = null;

  

  constructor(
    private pageContentService: PageContentService,
    protected sanitizer: DomSanitizer,
    private titleService: Title,
    
    private metaService: Meta) { }

  getPageData() {
    this.pageContentService.getData(this.pageUrl).subscribe((response) => {
      if (response.primaryContent.startsWith("<b>No content available") || response.primaryContent.indexOf('<h1 class="title">Coming soon!</h1>') >= 0) {
        this.primaryPageData$ = "";
      }
      else {
        
        //if (this.mediaReplacement !== null && this.mediaReplacement !== undefined) {
        //  console.log("Media replacement: " + this.mediaReplacement);
        //  this.primaryPageData$ = this.sanitizer.bypassSecurityTrustHtml(response.primaryContent.replace("|mediacontent|", this.mediaReplacement));
        //} else {
          this.primaryPageData$ = this.sanitizer.bypassSecurityTrustHtml(response.primaryContent);
        //}
        
        this.pageId$ = response.id;
      }

      this.titleService.setTitle(response.metaTitle);
      this.metaService.addTags([
        { name: 'keywords', content: response.metaKeywords },
        { name: 'description', content: response.metaDescription },
        { name: 'robots', content: 'index, follow' }
      ]);

      this.onLoaded.emit(null);

    });
  }

  ngOnInit() {
    try {
      this.getPageData();
    }
    catch (ex) {
      console.log(ex);
    }
    
  }

  ngAfterContentInit() {
  }

}
